import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { effectGroups } from '@/static/effectName'


export default /*#__PURE__*/_defineComponent({
  __name: 'EffectsCarouselPreloader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(effectGroups), (group) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "hidden",
      key: group.name
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.effects, (effect) => {
        return (_openBlock(), _createElementBlock("div", {
          key: effect.thumbnail
        }, [
          _createElementVNode("img", {
            src: `https://static.serato.com/visualizer/images/${effect.thumbnail}-small-1x.jpg`
          }, null, 8, _hoisted_1),
          _createElementVNode("img", {
            src: `https://static.serato.com/visualizer/images/${effect.thumbnail}-small-2x.jpg`
          }, null, 8, _hoisted_2),
          _createElementVNode("img", {
            src: `https://static.serato.com/visualizer/images/${effect.thumbnail}-small-1x.webp`
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            src: `https://static.serato.com/visualizer/images/${effect.thumbnail}-small-2x.webp`
          }, null, 8, _hoisted_4)
        ]))
      }), 128))
    ]))
  }), 128))
}
}

})